import{jsx as r}from"react/jsx-runtime";import{c as o}from"./createSvgIcon-7d989ad9.js";var t=o(r("path",{d:"M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"}),"Close");export{t as C};
